/* eslint-disable */
import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import axios from "axios";
import Select from "react-select";
import update from "immutability-helper";
import { validated } from "react-custom-validation";
import { format } from "date-fns";
import { GET_FORMPOST, GET_DETAILDATA } from "../../actions";
import {
  showLoader,
  userID,
  hideLoader,
  showAlert,
  isSingleSelect,
  showContaimerLoader,
  showPriceValue,
} from "../Settings/Settings";
import { apiUrl, headerconfig } from "../Settings/Config";
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
var module = "products/";
var moduleName = "Purchase Products";
class Form extends Component {
  constructor(props) {
    super(props);
    var saleID = this.props.match.params?.saleID || "";
    this.state = {
      userID: userID(),
      saleID: saleID,
      postdata: {
        vendor: "",
        purchaseInvoiceNumber:"",
        products: [
          {
            product: "",
            qty: "",
            price: "",
            totalPrice: "",
          },
        ],
        totalPrice: 0,
        gstAmount: 0,
        grandtotalPrice: 0,

      },
      detaildata: [],
      vendorList: [],
      productList: [],
      error_msg: "",
      pageloading: false,
    };
  }

  componentDidMount() {
    this.loadVendor();
    this.loadProduct();
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      this.state.formpost !== nextProps.formpost &&
      this.props.formpost != nextProps.formpost
    ) {
      if (nextProps.formpost.length > 0) {
        hideLoader("submit_frm", "class");
        var errMsg = nextProps.formpost[0].message;
        if (nextProps.formpost[0].status === "success") {
          showAlert("Success", errMsg, "success", "No");
          this.props.history.push("/purchase");
        } else {
          showAlert("Error", errMsg, "error", "No");
        }
      }
    }
  }
  loadVendor() {
    var urlShringTxt =
      apiUrl + "vendors/dropdownlist?&userID=" + this.state.userID;
    axios.get(urlShringTxt, headerconfig).then((res) => {
      if (res.data.status === "ok") {
        this.setState({ vendorList: res.data.result });
      }
    });
  }
  loadProduct() {
    var urlShringTxt =
      apiUrl + "products/dropdownlist?&userID=" + this.state.userID;
    axios.get(urlShringTxt, headerconfig).then((res) => {
      if (res.data.status === "ok") {
        this.setState({ productList: res.data.result });
      }
    });
  }

  sateValChange = (field, value) => {};

  /* signin - start*/
  fieldChange = (field, value) => {
    console.log(field, value, 'valuevaluevaluevalue')
    this.setState(
      update(this.state, { postdata: { [field]: { $set: value } } }), ()=> {
        var  totalPrice =  this.state.postdata.totalPrice;
        var gstAmount = this.state.postdata.gstAmount;
        var grandtotalPrice = parseFloat(totalPrice) + parseFloat(gstAmount);
        this.setState(
          update(this.state, { postdata: { grandtotalPrice: { $set: grandtotalPrice } } }), ()=> {    
          }
        );
        

      }
    );


  };

  handleSubmit = () => {
    showLoader("submit_frm", "class");
    var postData = this.state.postdata;

    var postObject = {
      vendorID: postData.vendor?.value || "",
      purchaseInvoiceNumber:postData.purchaseInvoiceNumber,
      products: JSON.stringify(postData.products),
      purchaseAmount: postData.totalPrice,
      gstAmount:postData.gstAmount,
      grandtotalPrice: postData.grandtotalPrice,
      userID: this.state.userID,
    };
    var post_url = "purchase/add";
    this.props.getFormPost(postObject, post_url, "add");
  };

  render() {
    return (
      <div>
        <div className="page">
          <div className="page-main">
            <Header currentPage="purchase" />

            <div className="main-content app-content">
              <div className="side-app">
                <div className="main-container container-fluid">
                  <div className="page-header">
                    <h1 className="page-title">{moduleName}</h1>
                    <div>
                      <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                          <Link to={"/purchase"}>
                            <i className="fa fa-arrow-left me-1"></i>
                            GoBack
                          </Link>
                        </li>
                      </ol>
                    </div>
                  </div>
                  <div className="row" id="modulefrm">
                    <div className="col-md-12 col-xl-12">
                      <div className="card">
                        {this.state.pageloading ? (
                          showContaimerLoader()
                        ) : (
                          <PostForm
                            {...this.props}
                            fields={this.state.postdata}
                            vendorList={this.state.vendorList}
                            productList={this.state.productList}
                            saleID={this.state.saleID}
                            onChange={this.fieldChange}
                            onValid={this.handleSubmit}
                            error_msg={this.state.error_msg}
                            onInvalid={() => {
                              console.log("Form invalid!");
                              setTimeout(function () {
                                if ($("#modulefrm .error").length > 0) {
                                  $("html, body").animate(
                                    {
                                      scrollTop:
                                        $(document)
                                          .find("#modulefrm .error:first")
                                          .offset().top - 100,
                                    },
                                    500
                                  );
                                }
                              }, 500);
                            }}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  return {
    formpost: state.formpost,
    detaildata: state.detaildata,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getFormPost: (formPayload, postUrl, postType) => {
      dispatch({ type: GET_FORMPOST, formPayload, postUrl, postType });
    },
    getDetailData: (datas) => {
      dispatch({ type: GET_DETAILDATA, datas });
    },
  };
};

export default connect(mapStateTopProps, mapDispatchToProps)(Form);

function validationConfig(props) {
  const { vendor } = props.fields;

  return {
    fields: ["vendor"],
    validations: {
      vendor: [[isSingleSelect, vendor]],
    },
  };
}

class PostForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      totalPrice: this.props.fields.totalPrice,
      grandtotalPrice: this.props.fields.grandtotalPrice,
    };
  }

  goBack() {
    this.props.history.push("/" + module);
  }
  handleSelectChange(name, value) {
    this.props.onChange(name, value);
  }

  handleChange(name, value) {
    this.props.onChange(name, value);
  }

  handleSelectProChange(updIndex, name, value) {
    this.updateSelectProduct(updIndex, name, value);
  }
  handleChangeText(updIndex, name, e) {
    this.updateSelectProduct(updIndex, name, e.target.value);
  }
  updateSelectProduct(updIndex, name, value) {
    var products = this.props.fields.products;
    var updPro = [];
    var totalPrice = 0;

    products.map((item, index) => {
      if (index === updIndex) {
        var product = name === "product" ? value : item.product;
        var qty = name === "qty" ? value : item.qty;
        var price = name === "price" ? value : item.price;

        var totalPrice =
          parseInt(qty) > 0 && parseFloat(price) > 0
            ? qty * parseFloat(price)
            : "";
        console.log(product?.productPrice, qty);
        updPro.push({
          product: product,
          qty: qty,
          price: price,
          totalPrice: totalPrice,
        });
      } else {
        updPro.push(item);
      }
    });
    var lastQtyVal = "";
    updPro.map((item, index) => {
      if (item.totalPrice !== "") {
        totalPrice += parseFloat(item.totalPrice);
      }
      if (
        item.qty !== "" &&
        item.product !== "" &&
        updPro.length === parseInt(index) + 1
      ) {
        lastQtyVal = "Yes";
      }
    });
    if (lastQtyVal === "Yes") {
      updPro.push({
        product: "",
        qty: "",
        price: "",
        totalPrice: "",
      });
    }
    this.props.onChange("products", updPro);
    setTimeout(() => {
      this.setState({ totalPrice: totalPrice }, () => {
        this.props.onChange("totalPrice", totalPrice);
      });
    }, 800);
    
  }

  render() {
    const { fields, onChange, onValid, onInvalid, $field, $validation } =
      this.props;
    let errMsgvendor = "";

    if ($validation.vendor.error.reason !== undefined) {
      errMsgvendor = $validation.vendor.show && (
        <span className="error">{$validation.vendor.error.reason}</span>
      );
    }

    return (
      <div>
        <div className="card-body">
          <div className="form-row">
            {this.props.saleID === "" && (
              <div className="form-group col-md-4">
                <label className="form-label">
                  Vendor<span className="lbl-error">*</span>
                </label>
                <Select
                  value={fields.vendor}
                  onChange={this.handleSelectChange.bind(this, "vendor")}
                  placeholder="Select Vendor"
                  isClearable={true}
                  options={this.props.vendorList}
                />
                {errMsgvendor}
              </div>
            )}
          </div>

          {fields.vendor !== "" && (
            <div className="row pt-5">
              <div className="col-lg-6">
                <p className="h3">Sale To:</p>
                <p className="fs-18 fw-semibold mb-0">{fields.vendor?.label}</p>
                <address>
                  {fields.vendor?.vendorAddress}, <br />
                  <br />
                  Contact Person:{fields.vendor?.vendorContactPerson}
                  {fields.vendor?.vendorPhone !== "" &&
                    fields.vendor?.vendorPhone !== null && (
                      <>
                        <br />
                        {fields.vendor?.vendorPhone}
                      </>
                    )}
                  {fields.vendor?.vendorEmail !== "" &&
                    fields.vendor?.vendorEmail !== null && (
                      <>
                        <br />
                        {fields.vendor?.vendorEmail}
                      </>
                    )}
                  {fields.vendor?.vendorGSTNo !== "" &&
                    fields.vendor?.vendorGSTNo !== null && (
                      <>
                        <br />
                        <b>GSTNo.:</b>
                        {fields.vendor?.vendorGSTNo}
                      </>
                    )}
                </address>
              </div>
              <div className="col-lg-6 text-end"></div>
            </div>
          )}
          <div className="form-group col-md-3">
            <label className="form-label">Invoice Number</label>
            <input
              type="text"
              className="form-control"
              placeholder="Invoice Number"
              name="purchaseInvoiceNumber"
              value={fields.purchaseInvoiceNumber}
              {...$field("purchaseInvoiceNumber", (e) =>
                onChange("purchaseInvoiceNumber", e.target.value)
              )}
              maxLength={255}
            />
          </div>
          <div className="push">
            <table className="table table-bordered table-hover mb-0 text-nowrap">
              <tbody>
                <tr>
                  <th className="text-center"></th>
                  <th style={{ width: "50%" }}>Item</th>
                  <th className="text-center">Quantity</th>
                  <th className="text-end">Unit Price</th>
                  <th className="text-end">Sub Total</th>
                </tr>
                {fields.products.map((item, index) => {
                  return (
                    <tr key={index}>
                      <td className="text-center">{parseInt(index) + 1}</td>
                      <td>
                        {this.props.saleID !== "" ? (
                          <div>{item.product.label}</div>
                        ) : (
                          <Select
                            value={item.product}
                            onChange={this.handleSelectProChange.bind(
                              this,
                              index,
                              "product"
                            )}
                            placeholder="Select Product"
                            isClearable={true}
                            options={this.props.productList}
                          />
                        )}
                      </td>
                      <td className="text-center">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Qty"
                          name="qty"
                          value={item.qty}
                          autoComplete="off"
                          onChange={this.handleChangeText.bind(
                            this,
                            index,
                            "qty"
                          )}
                          maxLength={6}
                        />
                      </td>
                      <td className="text-end">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Price"
                          name="price"
                          autoComplete="off"
                          value={item.price}
                          onChange={this.handleChangeText.bind(
                            this,
                            index,
                            "price"
                          )}
                        />
                      </td>
                      <td className="text-end">
                        {showPriceValue(item.totalPrice)}
                      </td>
                    </tr>
                  );
                })}
                <tr>
                  <td colSpan="4" className="fw-bold text-uppercase text-end">
                    Total
                  </td>
                  <td className="fw-bold text-end h4">
                    {showPriceValue(this.state.totalPrice)}
                  </td>
                </tr>
                <tr>
                  <td
                    colSpan="4"
                    className="fw-bold text-uppercase text-end"
                  >
                    GST
                  </td>
                  <td className="fw-bold text-end h4">
                  <input
                          type="text"
                          className="form-control"
                          placeholder="GST"
                          name="gstAmount"
                          {...$field("gstAmount", (e) =>
                            onChange("gstAmount", e.target.value)
                          )}
                          value={fields.gstAmount}
                        />
                  </td>
                </tr>
                <tr>
                  <td colSpan="4" className="fw-bold text-uppercase text-end">
                    Grand Total
                  </td>
                  <td className="fw-bold text-end h4">
                    {showPriceValue(fields.grandtotalPrice)}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div className="card-footer">
          <div className="btn-toolbar sw-toolbar sw-toolbar-bottom justify-content-end">
            <div
              className="btn-group me-2 sw-btn-group-extra submit_frm"
              role="group"
            >
              <button
                className="btn btn-primary"
                onClick={(e) => {
                  e.preventDefault();
                  this.props.$submit(onValid, onInvalid);
                }}
              >
                Create Purchase
              </button>

              <button
                className="btn btn-secondary"
                onClick={this.goBack.bind(this)}
              >
                Back
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
PostForm = validated(validationConfig)(PostForm);
